import React, {useEffect} from 'react';

const WhizzcoSidebarUnit = () => {
    useEffect(() => {

        const script = document.createElement('script');
        script.src = 'https://cdn.whizzco.com/scripts/widget/widget_v3.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            script.remove();
        };

    }, []);

    return (
        <div className="ads_container" style={{marginBottom: '16px'}} website_id="2876" widget_id="7034" />
    );
};

export default WhizzcoSidebarUnit;
